import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=a92dec76&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a92dec76')) {
      api.createRecord('a92dec76', component.options)
    } else {
      api.reload('a92dec76', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=a92dec76&", function () {
      api.rerender('a92dec76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/Main.vue"
export default component.exports